module.exports = __webpack_public_path__ + "static/media/onemenu.354ac7c7.svg";